import _typeof from '@babel/runtime/helpers/typeof';
import cookie from 'cookie';
import isPlainObject from 'lodash/isPlainObject';
import { isServer, isKaeRelease } from '@kso/util';

var Def = function Def() {};

// 只获取一次 性能问题
var _cookies = {};
if (!isServer()) {
  _cookies = cookie.parse(document.cookie) || {};
}
var csrfInCookie = _cookies.csrf;
function _createCsrfToken() {
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var token = '';
  for (var i = 0; i < 32; i++) {
    token += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return token;
}
function _setCsrfTokenCookie(token) {
  var hostname = (typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object' && location.hostname || '';
  var isIpAddress = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g.test(hostname);
  var obj = {
    path: '/'
  };
  if (isIpAddress) {
    // ip 处理
    obj.domain = hostname;
  } else if (hostname) {
    // 域名处理，结合公网之前的逻辑，域名大于两段区，截取去掉最低一层的域名，域名小于等于两段直接取当前域名
    if (hostname.split('.').length > 2) {
      obj.domain = hostname.match(/(\.[\w-]+){1,}$/) && hostname.match(/(\.[\w-]+){1,}$/)[0];
    } else {
      obj.domain = '.' + hostname;
    }
  }
  document.cookie = cookie.serialize('csrf', token, obj);
}
function request(config) {
  var data = config.data,
    method = config.method,
    headers = config.headers,
    url = config.url;
  if (method === 'options') {
    return config;
  }
  var token = csrfInCookie;
  if (!token) {
    // 生成新的token
    token = _createCsrfToken();
    // 写入cookie
    !isServer() && _setCsrfTokenCookie(token);
    // 赋值给外层变量，下次调用不需要再次生成
    csrfInCookie = token;
  }

  // POST PUT DELETE
  if (~['post', 'put', 'delete'].indexOf(method)) {
    if (isPlainObject(data)) {
      data.csrfmiddlewaretoken = token;
    } else if (data instanceof (typeof FormData !== 'undefined' && FormData || Def)) {
      // data.append('csrfmiddlewaretoken', token)
      headers['X-CSRFToken'] = token;
    } else if (!data) {
      config.data = {
        csrfmiddlewaretoken: token
      };
      // headers['X-CSRFToken'] = token /kdg/api 接口不支持多余的header调用
    }
    if (isKaeRelease('oem') && url.indexOf('/woa') !== -1) {
      headers['X-CSRFToken'] = token;
    }
  }
  return config;
}
function csrftoken () {
  this.$inject({
    name: 'csrftoken',
    request: request
  });
}

export { csrftoken as default };
